import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import BannerImg from '../images/img1.jpg'; 
import icon1 from '../images/1.png';
import icon2 from '../images/2.png';
import icon3 from '../images/3.png';
// import image5 from '../images/ndis.png';

const cards = [
  {
    name: 'Allied Health',
    description: 'Allied Health professionals deliver specialized support to help individuals achieve independence and improve their quality of life.',
    icon: icon1,
    path: '/services/positive-behaviour-support-practitioner'
  },
  {
    name: 'Disability Support Worker',
    description: 'Support workers provide assistance and support to individuals who may need help with various aspects of daily living.',
    icon: icon2,
    path: '/services/disability-support-worker'
  },
  {
    name: 'Supported Independent Living',
    description: 'Supported Independent Living (SIL) provides 24/7 constant support to help individuals manage everyday tasks.',
    icon: icon3,
    path: '/services/supported-independent-living'
  },
]

export default function Example() {
  return (
    <div className="bg-white">
      <div className="relative isolate overflow-hidden bg-gradient-to-b from-indigo-100/20 pt-0">
        <div
          aria-hidden="true"
          className="absolute inset-y-0 right-1/2 -z-10 -mr-96 w-[200%] origin-top-right skew-x-[-30deg] bg-custom-1 shadow-xl shadow-indigo-600/10 ring-1 ring-indigo-50 sm:-mr-80 lg:-mr-96"
        />
        <div className="mx-auto max-w-7xl px-6 py-16 sm:py-20 lg:px-8">
          <div className="mx-auto max-w-2xl lg:mx-0 lg:grid lg:max-w-none lg:grid-cols-2 lg:gap-x-16 lg:gap-y-6 xl:grid-cols-1 xl:grid-rows-1 xl:gap-x-8">
            <motion.h1
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              className="max-w-2xl text-4xl font-bold tracking-tight text-gray-900 sm:text-7xl lg:col-span-2 xl:col-auto"
            >
              Enhanced Wellbeing
            </motion.h1>
            <div className="mt-6 max-w-xl lg:mt-0 xl:col-end-1 xl:row-start-1">
            <motion.p
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="mt-6 font-bold text-xl leading-8 text-gray-500"
            >
              At Enhanced Wellbeing, we are passionate about providing high quality and personalized support for people with disabilities. Our expert team is committed to empowering individuals to achieve their goals and enhance their quality of life.
            </motion.p>

            <motion.p
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.4 }}
              className="mt-3 font-bold text-2xl leading-8 text-gray-700"
            >
              Enhanced Wellbeing is a Registered NDIS Provider.
            </motion.p>
            <motion.div
              initial={{ opacity: 0, y: 30, scale: 0.95 }}
              animate={{ opacity: 1, y: 0, scale: 1 }}
              transition={{
                type: 'spring',
                stiffness: 200,
                damping: 15,
                delay: 0.5,
              }}
              className="mt-10 flex flex-col items-start gap-4 md:flex-row"
            >
              <Link
                to="/services"
                className="inline-block py-4 px-8 w-auto text-lg font-semibold text-white border-2 border-white rounded-full transition duration-150 ease-in-out bg-gradient-to-r from-purple-500 via-pink-500 to-red-500 hover:from-red-600 hover:via-pink-600 hover:to-purple-600"
              >
                Explore our services&nbsp;<span aria-hidden="true">&rarr;</span>
              </Link>
              <Link
                to="/contact"
                className="inline-block py-4 px-8 w-auto text-lg font-semibold text-gray-600 border-2 border-gray-600 rounded-full transition duration-300 ease-in-out hover:bg-white hover:text-purple-600"
              >
                Get in touch&nbsp;<span aria-hidden="true">&rarr;</span>
              </Link>
            </motion.div>
          </div>
            <motion.img
              initial={{ opacity: 0, scale: 0.7 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{
                type: 'spring',
                stiffness: 260,
                damping: 20,
                delay: 0.2
              }}
              alt=""
              src={BannerImg}
              className="mt-10 aspect-[6/5] w-full max-w-lg rounded-2xl object-cover sm:mt-16 lg:mt-0 lg:max-w-none xl:row-span-2 xl:row-end-2 xl:mt-36"
            />
          </div>
        </div>
      </div>
      <div className="py-0 mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-3xl py-8 lg:mx-0">
          <h2 className="mt-5 text-2xl font-bold tracking-tight text-black sm:text-4xl">
            What type of NDIS support are you looking for?
          </h2>
        </div>
        <div className="md:grid mx-auto mt-0 mb-20 max-w-2xl grid-cols-1 gap-6 sm:mb-20 sm:mt-20 lg:mx-0 lg:max-w-none lg:grid-cols-3 lg:gap-16">
          {cards.map((card, index) => (
            <motion.div
              key={card.name}
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.2 }}
              viewport={{ once: true, amount: 0.2 }}
              whileHover={{
                scale: 1.05,
                boxShadow: '0px 12px 24px rgba(0, 0, 0, 0.1)',
              }}
              className="mb-6 sm:mb-0 h-full transition-transform duration-150 ease-out"
            >
            <Link
              to={card.path}
              className="h-full min-h-[300px] flex flex-col justify-start items-center gap-y-4 rounded-xl bg-custom-1/80 p-6 ring-1 ring-inset ring-white/10 text-center"
            >
              <img src={card.icon} alt={card.name} className="h-24 w-24 object-cover aspect-square rounded-lg" />
              <div className="text-base leading-7">
                <h3 className="font-semibold text-black">{card.name}</h3>
                <p className="mt-2 text-gray-900">{card.description}</p>
              </div>
              <div className="flex-grow" /> 
            </Link>
          </motion.div>
          
          ))}
        </div>
      </div>
    </div> 
  )
}
